import axios from 'axios'

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ??
    'https://redsterna-api-v2-production.up.railway.app/'
})

const sortCitiesByOrder = (payload: any): any => {
  if (Array.isArray(payload)) {
    return payload.map((item) => sortCitiesByOrder(item))
  }

  if (!payload || typeof payload !== 'object') return payload

  const normalized = Object.keys(payload).reduce(
    (result: Record<string, any>, key) => {
      result[key] = sortCitiesByOrder(payload[key])
      return result
    },
    {}
  )

  if (Array.isArray(normalized.cities)) {
    normalized.cities = [...normalized.cities].sort((cityA, cityB) => {
      const orderA = Number(cityA?.order)
      const orderB = Number(cityB?.order)
      const hasOrderA = Number.isFinite(orderA) && orderA > 0
      const hasOrderB = Number.isFinite(orderB) && orderB > 0

      if (hasOrderA && hasOrderB && orderA !== orderB) {
        return orderA - orderB
      }

      if (hasOrderA !== hasOrderB) return hasOrderA ? -1 : 1

      const createdAtA = cityA?.createdAt
        ? new Date(cityA.createdAt).getTime()
        : Number.MAX_SAFE_INTEGER
      const createdAtB = cityB?.createdAt
        ? new Date(cityB.createdAt).getTime()
        : Number.MAX_SAFE_INTEGER

      return createdAtA - createdAtB
    })
  }

  return normalized
}

api.interceptors.request.use((config: any) => {
  try {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
  } catch (err) {
    console.error(err)
  }

  return config
})

api.interceptors.response.use(
  (response) => {
    response.data = sortCitiesByOrder(response.data)
    return response
  },
  (error) => {
    const status = error?.response?.status
    const hasToken = Boolean(window.localStorage.getItem('token'))

    if (status === 401 && hasToken) {
      const message = String(
        error?.response?.data?.message || 'Sua sessão foi encerrada.'
      )

      delete api.defaults.headers.common.Authorization
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('user')
      window.sessionStorage.setItem('authMessage', message)

      if (!window.location.pathname.startsWith('/auth')) {
        window.location.replace('/')
      }
    }

    return Promise.reject(error)
  }
)

export default api
